import React from 'react';
import logo from './logo.svg';
import './App.css';
import './styles.scss'
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Header from './components/Header/Header'
import DynamicPage from './components/DynamicPage'
import Index from './pages/Index'

function App() {

  const baseUrl = '/';

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Header title="Instrumentación HSE" />}>
            <Route index element={<Index />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
